import { request } from '../request'

interface GetHostList {
  page: number
  size: number
  hostname?: string
  hostIp?: string
  os?: string[]
  arch?: string[]
  status?: string[]
  areaIds?: string[]
  field?: string | undefined
  order?: string
  deviceId?: string
}

// 获取验证主机列表
const getHostList = (params: GetHostList) =>
  request('/portal/v1/host', {
    method: 'GET',
    params,
  })

interface UpdateHost {
  areaId?: string
  deviceIds?: string[]
  hostId?: string
  hostname?: string
  remark?: string
}
// 更新验证主机信息
const updateHost = (data: UpdateHost) =>
  request(`/portal/v1/host/${data.hostId}`, {
    method: 'PUT',
    data,
  })

// 获取验证主机详情
const getHostDetail = (id: string) => request(`/portal/v1/host/${id}`)

// 获取安全域列表
const getSecurityDomainList = () => request('/portal/v1/host/filter/area')

export { getHostList, updateHost, getHostDetail, getSecurityDomainList, GetHostList, UpdateHost }
